
export const getItemToLocalStorage = (key, devaultValue) =>
localStorage.getItem(key) || devaultValue;
export const setItemToLocalStorage = (key, value) =>
localStorage.setItem(key, value);
